 const COLORS = {
    white: '#fff',
    black: '#000',
    orangepeel: '#ff9803',
    carmine: '#B04645'
}

export default COLORS;